import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  isLoaderVisible: any = false;
  customerTestInstanceArray: any = [];
  currentIndex: any;
  backinstance: boolean = false;
  editAnalysisSpec: any = [];
  initialCTTDetails: any[] = [];
  initialCTTResponse: any = [];
  public analyzeStepState: any = null;
  calibrateFITDetails: any = [];
  selectedTestInstanceSetAnalysisID: any;
  constructor() {
  }

 
}
